import { getFirestore, collection, addDoc, getDocs, deleteDoc, doc, query, where } from 'firebase/firestore';
import { getFirebaseApp } from './firebaseConfig';

const db = getFirestore(getFirebaseApp());
const colorsCollection = collection(db, 'colors');

export async function addColorToFirestore(name, uid) {
  const docRef = await addDoc(colorsCollection, { name, uid });
  return docRef.id;
}

export async function getColorsFromFirestore(uid) {
  let q = colorsCollection;
  if (uid) {
    q = query(colorsCollection, where('uid', '==', uid));
  }
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
}

export async function deleteColorFromFirestore(id) {
  await deleteDoc(doc(colorsCollection, id));
}
